import { z } from "zod";
export const JOB_APPLICATION_ATTACHMENT_MAX_BYTES = 5 * 1024 * 1024;
export const jobApplicationAttachmentContentTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
// Base64 inflates by 4/3, so the encoded string for a file at the byte cap is
// ceil(max / 3) * 4 characters.
const ATTACHMENT_MAX_BASE64_LENGTH = Math.ceil(JOB_APPLICATION_ATTACHMENT_MAX_BYTES / 3) * 4;
export const jobApplicationRequestSchema = z.object({
    jobSlug: z.string().trim().min(1).max(200),
    jobTitle: z.string().trim().min(1).max(200),
    name: z.string().trim().min(1).max(200),
    email: z.string().trim().email(),
    phone: z.string().trim().min(1).max(50),
    city: z.string().trim().min(1).max(200),
    education: z.string().trim().min(1).max(500),
    engagement: z.enum(["invoicing", "employment", "either"]),
    workload: z.enum(["part_time", "growing_full_time"]),
    startDate: z.string().trim().min(1).max(200),
    about: z.string().trim().min(1).max(5000),
    attachment: z
        .object({
        filename: z.string().trim().min(1).max(255),
        contentType: z.enum(jobApplicationAttachmentContentTypes),
        dataBase64: z.string().min(1).max(ATTACHMENT_MAX_BASE64_LENGTH),
    })
        .optional(),
    consent: z.literal(true),
    // Honeypot -- same contract as contactRequestSchema.company.
    company: z.string().max(200).optional(),
});
